import {
  resolveBobcatAccess,
  type BobcatAccess,
  type BobcatFlagName,
} from '../utils/bobcat-flags';
import { useProStudioCtxSelector } from '../xstate/app.xstate';

/**
 * Tri-state gate for a Project Bobcat surface.
 *
 * ```tsx
 * const access = useBobcatFlag('validateStage');
 * if (access === 'pending') return <Loader relative />;
 * if (access === 'denied') return <Navigate to={routes.versions.path} replace />;
 * ```
 *
 * Selecting `ctx.featureFlags` by reference is what makes `pending` reachable:
 * it is `undefined` until LaunchDarkly answers. See `resolveBobcatAccess` for
 * why that must not collapse into "off".
 */
export const useBobcatFlag = (flag: BobcatFlagName): BobcatAccess => {
  const featureFlags = useProStudioCtxSelector((ctx) => ctx.featureFlags);

  return resolveBobcatAccess(flag, featureFlags);
};
